import { sendToApi } from 'api/client'
import { AudienceMetric } from './types'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

const fetchAudienceMetrics = async (workspaceId: number, integrationId: number) => {
  const response = await sendToApi<{ audience_metrics: AudienceMetric[] }>(
    `/w/${workspaceId}/external_integrations/${integrationId}/audience_metrics`,
  )

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(response.data)
  }

  return response.data.audience_metrics
}

export const useAudienceMetrics = (integrationId: number) => {
  const workspaceId = useCurrentWorkspaceId()
  return useQuery<AudienceMetric[], Error>({
    queryKey: ['audience-metrics', integrationId],
    queryFn: () => fetchAudienceMetrics(workspaceId, integrationId),
    refetchOnWindowFocus: false,
  })
}
